import { lazy } from "react";

import { PATHS } from "../path";

const NotFoundPage = lazy(() => import("@/modules/ErrorPages/NotFound"));
const LoginTroublePage = lazy(
  () => import("@/modules/ErrorPages/LoginTroublePage")
);

export const errorRoutes = [
  {
    path: PATHS.NOT_FOUND,
    element: <NotFoundPage />,
  },
  {
    // TODO: added to login page when we have some trouble
    path: PATHS.LOGIN_ERROR,
    element: <LoginTroublePage />,
  },
];
